import { GET_HOLIDAY_LIST_FOR_MANAGE_HOLIDAY_SUCCESS, GET_HOLIDAY_LIST_FOR_MANAGE_HOLIDAY_FAILURE } from "../constants/MyM";

const initStat = { data: [], error: false, errorData: "", isLoading: true };

export default (state = initStat, action) => {
  switch (action.type) {
    case GET_HOLIDAY_LIST_FOR_MANAGE_HOLIDAY_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };
    case GET_HOLIDAY_LIST_FOR_MANAGE_HOLIDAY_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorData: action.payload,
        error: true,
      };
    default:
      return { ...state };
  }
};
